import React, { useState, useEffect, useMemo, useCallback } from "react";
import { useLocation } from "react-router-dom";
import useCustomNavigate from "../../common_nextgen/common_components/Navigation/NextGenNavigation";
import Form from "../../common_nextgen/common_components/form/Form";
import {
  PRICE_SCHEDULE_MODES,
  LEGACY_SCREEN_VIEW,
  NO_CHANGE_OF_INFO
} from "../../common_nextgen/utils/Constants";
import {
  isAddMode,
  isEditMode,
  isReadOnlyMode,
  LegacyResolvers,
} from "../../common_nextgen/utils/UtilFunctions";
import { useAxios } from "../../common_nextgen/axios/AxiosHelper";
import { useToast } from "../../common_nextgen/hooks/ToastContext";
import FunctionKeys from "../../common_nextgen/common_components/FunctionKeys/FunctionKeys";
import { formFields } from "./OutofPocketMaxDetailConfig";
import { ROUTE_PATHS } from "../../common_nextgen/utils/Constants";
import { useModal } from "../../common_nextgen/hooks/ModalContext";


const screenInfo = {
  ADD: ["Add Out of Pocket Maximum Schedule Step", "RCOPD003"],
  CHANGE: ["Out of Pocket Maximum Schedule Step Detail", "RCOPD002"],
  VIEW: ["Out of Pocket Maximum Schedule Step Detail", "RCOPD002"],
};

const OutOfPocketMaxDetailForm = ({ mode }) => {
  const {
    OUT_OF_POCKET_MAX_SCHEDULE_STEPS,
    OUT_OF_POCKET_MAX_SCHEDULE_STEPS_DETAILS_EXT,
    OUT_OF_POCKET_MAX_SCHEDULE_SUB_STEPS,
    OUT_OF_POCKET_PATIENT_PAY_SCHEDULE,
    OUT_OF_POCKET_MAX_SCHEDULE,
  } = ROUTE_PATHS;
  const location = useLocation();
  const { axios_helper_no_header } = useAxios();
  /*const {
    selectedSteps = [],
    previousScreen = OUT_OF_POCKET_MAX_SCHEDULE_STEPS,
    currentIndex: initialIndex = 0,
    scheduleName,
    selectedSteps[currentIndex].opdStepNumber,
    paramsData

    // basis
    // stepcount
    // desccription

  } = location.state || {};*/
  const { state: stateVal } = location;
  let [currentState = {}] = [...stateVal].reverse();
  const previousState = [...stateVal];
  previousState.splice(stateVal.length - 1, 1);
  //console.log("current state in form", currentState, previousState);
  let {
    selectedSteps = [],
    previousScreen = OUT_OF_POCKET_MAX_SCHEDULE,
    currentIndex: initialIndex = 0,
    paramsData,
    scheduleName,
  } = currentState;
  console.log("current state", currentState);

  const navigateToPage = useCustomNavigate();
  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const [currentMode, setCurrentMode] = useState(mode);
  const [initialFormData, setInitialFormData] = useState({});
  const [constraintErrors, setConstraintErrors] = useState([]);
  const toast = useToast();

  const { showModal } = useModal();
  const [lookupData, setLookupData] = useState({});
  const handleReceiveData = (data) => {
    //setInitialFormData({ ...initialFormData, ...data });
    if (data && Object.keys(data).length) {
      setLookupData(data);
    }
  };
  const fetchLookupData = (lookupScreen, params, formData) => {
     const updatedFormData = { ...formData };
    if (lookupScreen.default === "RCPLN018" && formData.planCode === "") {
      updatedFormData.planEffDate = "";
      updatedFormData.planName = "";
    }
    showModal(lookupScreen, { params }, handleReceiveData, updatedFormData);
  };

  const viewLookupDetails = (lookupScreen, params, formData) => {
    const { viewType, fieldMapping } = params;
    const { default: screenNumber } = lookupScreen;
    if (viewType === "legacy") {
      const { default: viewParams } = fieldMapping;
      const paramData = viewParams.reduce((acc, item) => {
        const resolver = item["resolver"] ? LegacyResolvers[item["resolver"]] : null ;
        acc[item["legacy"]] = resolver ? resolver(formData[item["source"]]): formData[item["source"]];
        return acc;
      }, {});
      const message = {
        message: "navigate-to-presto",
        programCode: LEGACY_SCREEN_VIEW[screenNumber],
        parameters: paramData,
      };
      console.log("message", message);
      window.top?.postMessage(message, "*");
    } else {
      showModal(lookupScreen, { params }, null, formData, true);
    }
  };

  const handleBack = useCallback(() => {
    if (currentIndex < selectedSteps.length - 1) {
      setCurrentIndex(currentIndex + 1);
      setCurrentMode(mode);
    } else {
      navigateToPage(previousScreen, previousState);
    }
  }, [currentIndex, selectedSteps]);

  const getPageTitle = useCallback(() => {
    const [screenTitle, screenNumber] = isAddMode(currentMode)
      ? screenInfo.ADD
      : screenInfo.CHANGE;
    return (
      <>
        <span className="title">{screenTitle}</span>
        <span>{"-"}</span>
        <span className="screen-number">{screenNumber}</span>
      </>
    );
  }, [currentMode]);

  const submitForm = async (dataForSubmission) => {
    let url = "";
    let verb = "";
    let screenNumber = "";
    let infoChanged = true;

    if (isAddMode(currentMode)) {
      url = "api/opdOutPoktMaxSchDtl/create";
      verb = "POST";
      screenNumber = screenInfo.ADD[1];
    } else {
      url = "api/opdOutPoktMaxSchDtl/update";
      verb = "PUT";
      screenNumber = screenInfo.CHANGE[1];

      if (
        JSON.stringify(dataForSubmission) === JSON.stringify(initialFormData)
      ) {
         infoChanged = false;
      }
    }

    const data = { ...dataForSubmission, screenNumber, infoChanged };

    try {
      const { responseStatus, responseData } = await axios_helper_no_header(
        verb,
        url,
        data,
        null
      );
      if (responseStatus.message === NO_CHANGE_OF_INFO) {
                         toast.current.show({
                           severity: "info",
                           summary: "",
                           detail: responseStatus.message,
                           life: 3000,
                         });
                       } else {
                         toast.current.show({
                           severity: "success",
                           summary: "",
                           detail: responseStatus.message,
                           life: 3000,
                         });
      setInitialFormData(responseData);
      if (isAddMode(currentMode)) {
        setCurrentMode(PRICE_SCHEDULE_MODES.EDIT);
        currentState = {
          ...currentState,
          selectedSteps: [{ ...responseData }],
          currentIndex: 0,
        };

          var paramsData = {
            description: currentState.selectedSteps[currentIndex].opcDescription,
            steps: currentState.selectedSteps[currentIndex].opdStepNumber,
            opcScheduleName: currentState.selectedSteps[currentIndex].opcScheduleName,
            basis: currentState.selectedSteps[currentIndex].opcBasis,
          }

        currentState = {paramsData, ...currentState}
        
        navigateToPage(ROUTE_PATHS.EDIT_OUT_OF_POCKET_MAX_SCHEDULE_DETAIL, [
          ...previousState,
          currentState,
        ]);
      }
      
    } }catch (error) {
      const { responseStatus: { displayErrorFields = null, message } = {} } =
        error.data;
      if (displayErrorFields === null) {
        toast.current.show({
          severity: "error",
          summary: "",
          detail: message,
          life: 3000,
        });
      } else {
        setConstraintErrors(displayErrorFields);
      }
    }
  };

  const [keyFunc, keyName] = useMemo(() => {
    const keyFunc = {};
    const keyName = {};

    if (isAddMode(currentMode)) {
      keyFunc.F12 = handleBack;
      /*navigateToPage("/out-of-pocket-schedule", {
          selectedPriceSchedules,
          currentMode,
          currentIndex,
        });*/
      keyName.F12 = "Back";
    } else if (isEditMode(currentMode)) {
      keyFunc.F12 = handleBack;
      /*navigateToPage("/out-of-pocket-schedule", {
          selectedPriceSchedules,
          currentMode,
          currentIndex,
        });*/
      keyName.F12 = "Back";
      keyFunc.chmod = () => setCurrentMode(PRICE_SCHEDULE_MODES.READ_ONLY);
      keyName.chmod = "View";
      keyFunc.F7 = () => detailExtensionValidation();
      keyName.F7 = "Detail Extension";
      keyFunc.F8 = () => subStepValidation();
      keyName.F8 = "Substep";
      keyFunc.F9 = () => patientPayValidation();
      keyName.F9 = "Patient Pay";
    } else if (isReadOnlyMode(currentMode)) {
      keyFunc.F12 = handleBack;
      /* navigateToPage("/out-of-pocket-schedule", {
          selectedPriceSchedules,
          currentMode,
          currentIndex,
        });*/
      keyName.F12 = "Back";
      keyFunc.chmod = () => setCurrentMode(PRICE_SCHEDULE_MODES.EDIT);
      keyName.chmod = "Edit";
      keyFunc.F7 = () => detailExtensionValidation();
      keyName.F7 = "Detail Extension";
      keyFunc.F8 = () => subStepValidation();
      keyName.F8 = "Substep";
      keyFunc.F9 = () => patientPayValidation();
      keyName.F9 = "Patient Pay";
    }

    return [keyFunc, keyName];
  }, [currentMode, currentIndex]);

  const subStepValidation = () => {
    var params = null;
    var navigateParams = null;
    if (isAddMode(currentMode)) {
      params = {
        opcScheduleName: initialFormData.opcScheduleName,
        opdStepNumber: selectedSteps[currentIndex].opdStepNumber,
        action: "sub-step",
      };
      navigateParams = {
        description: initialFormData.opcDescription,
        steps: initialFormData.opcStepCount,
        scheduleName: initialFormData.opcScheduleName,
        basis: initialFormData.opcBasis,
      };
    } else {
      console.log("paramsData", paramsData);
      params = {
        opcScheduleName: paramsData.opcScheduleName,
        opdStepNumber: selectedSteps[currentIndex].opdStepNumber,
        action: "sub-step",
      };
      navigateParams = {
        description: paramsData.description,
        steps: paramsData.steps,
        scheduleName: paramsData.opcScheduleName,
        basis: paramsData.basis,
      };
    }
    axios_helper_no_header(
      "GET",
      "api/opdOutPoktMaxSchDtl/validateStep",
      null,
      params
    )
      .then((response) => {
        navigateToPage(OUT_OF_POCKET_MAX_SCHEDULE_SUB_STEPS, [
          ...previousState,
          { ...currentState, currentIndex },
          {
            selectedSteps: [selectedSteps[currentIndex]],
            description: navigateParams.description,
            steps: navigateParams.steps,
            scheduleName: navigateParams.scheduleName,
            basis: navigateParams.basis,
            previousScreen: location.pathname,
            currentIndex: 0,
          },
        ]);
      })
      .catch((error) => {
        console.error("There was validation failed!!", error);
        const { responseStatus: { displayErrorFields = null, message } = {} } =
          error.data;
        toast.current.show({
          severity: "error",
          summary: "",
          detail: message,
          life: 3000,
        });
      });
  };

  const patientPayValidation = () => {
    var params = null;
    var navigateParams = null;
    if (isAddMode(currentMode)) {
      params = {
        opcScheduleName: initialFormData.opcScheduleName,
        opdStepNumber: selectedSteps[currentIndex].opdStepNumber,
        action: "patient-pay",
      };
      navigateParams = {
        description: initialFormData.opcDescription,
        scheduleName: initialFormData.opcScheduleName,
      };
    } else {
      params = {
        opcScheduleName: paramsData.opcScheduleName,
        opdStepNumber: selectedSteps[currentIndex].opdStepNumber,
        action: "patient-pay",
      };
      navigateParams = {
        description: paramsData.description,
        scheduleName: paramsData.opcScheduleName,
      };
    }
    axios_helper_no_header(
      "GET",
      "api/opdOutPoktMaxSchDtl/validateStep",
      null,
      params
    )
      .then((response) => {
        navigateToPage(OUT_OF_POCKET_PATIENT_PAY_SCHEDULE, [
          ...previousState,
          { ...currentState, currentIndex },
          {
            selectedSteps: [selectedSteps[currentIndex]],
            description: paramsData.description,
            steps: paramsData.steps,
            scheduleName: paramsData.opcScheduleName,
            basis: paramsData.basis,
            previousScreen: location.pathname,
            currentIndex: 0,
          },
        ]);
      })
      .catch((error) => {
        console.error("There was validation failed!!", error);
        const { responseStatus: { displayErrorFields = null, message } = {} } =
          error.data;
        toast.current.show({
          severity: "error",
          summary: "",
          detail: message,
          life: 3000,
        });
      });
  };

  const detailExtensionValidation = () => {
    var params = null;
    var navigateParams = null;
    if (isAddMode(currentMode)) {
      params = {
        opcScheduleName: initialFormData.opcScheduleName,
        opdStepNumber: selectedSteps[currentIndex].opdStepNumber,
        action: "detail-extension",
      };
      navigateParams = {
        description: initialFormData.opcDescription,
        scheduleName: initialFormData.opcScheduleName,
        steps: initialFormData.opcStepCount,
      };
    } else {
      params = {
        opcScheduleName: paramsData.opcScheduleName,
        opdStepNumber: selectedSteps[currentIndex].opdStepNumber,
        action: "detail-extension",
      };
      navigateParams = {
        description: paramsData.description,
        scheduleName: paramsData.opcScheduleName,
        steps: paramsData.steps,
      };
    }
    axios_helper_no_header(
      "GET",
      "api/opdOutPoktMaxSchDtl/validateStep",
      null,
      params
    )
      .then((response) => {
        navigateToPage(OUT_OF_POCKET_MAX_SCHEDULE_STEPS_DETAILS_EXT, [
          ...previousState,
          { ...currentState, currentIndex },
          {
            selectedSteps: [selectedSteps[currentIndex]],
            description: navigateParams.description,
            steps: navigateParams.steps,
            scheduleName: navigateParams.scheduleName,
            previousScreen: location.pathname,
            currentIndex: 0,
          },
        ]);
      })
      .catch((error) => {
        console.error("There was validation failed!", error);
        const { responseStatus: { displayErrorFields = null, message } = {} } =
          error.data;
        toast.current.show({
          severity: "error",
          summary: "",
          detail: message,
          life: 3000,
        });
      });
  };

  useEffect(() => {
    const fetchInitialData = async () => {
      console.log("paramsData->", paramsData);
      const url = isAddMode(currentMode)
        ? `api/opdOutPoktMaxSchDtl/initial-form-data/${encodeURIComponent(
            scheduleName
          )}`
        : `api/opdOutPoktMaxSchDtl/${encodeURIComponent(
            scheduleName
          )}?stepNumber=${selectedSteps[currentIndex]?.opdStepNumber}`;

      try {
        const { responseData } = await axios_helper_no_header("GET", url);
        setInitialFormData(responseData);
      } catch (e) {
        console.log(e);
      }
    };

    fetchInitialData();
  }, [mode, currentIndex]);

  return (
    <div className="grid container">
      <div className="col col-12">
        <FunctionKeys keyFunc={keyFunc} keyName={keyName} />
      </div>
      <div className="col col-12">
        <h1>{getPageTitle()}</h1>
      </div>
      <div className="col col-12">
        <Form
          formData={initialFormData}
          formFields={formFields}
          mode={currentMode}
          submitFormData={submitForm}
          constraintErrors={constraintErrors}
          fetchLookupData={fetchLookupData}
          lookupData={lookupData}
          viewLookupDetails={viewLookupDetails}
        />
      </div>
    </div>
  );
};

export default OutOfPocketMaxDetailForm;
